<template>
    <div class="single-video-container" @click="toVideo(video)">
        <img :src="video.img" alt="图片加载失败" />
        <div class="video-title">{{ video.title }}</div>
        <div class="video-icon">
            <span>
                <i class="el-icon-video-play"></i>
                {{video.views}}
            </span>
            <span v-if="video.money > 0">
                <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icondaozhangshijian" />
                </svg>
                {{video.money}}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            video: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        methods: {
            toVideo(item) {
                this.httpGet(this.$root.getCrumbsDetail, {
                    id: this.type == 'collection' ? item.aid : item.id,
                    type: 'article'
                })
                    .then(result => {
                        // 面包屑
                        let breadObj = [
                            {
                                id: result.id,
                                path: 'article-list?id=' + result.id,
                                name: result.title
                            }
                        ];
                        if (result.children.length) {
                            breadObj.push({
                                id: result.children.id,
                                path: 'article-list?id=' + result.children.id,
                                name: result.children.title
                            });
                        }
                        this.$store.commit('setBreadArr', breadObj);
                    })
                    .catch(err => {
                        console.error('getCrumbsDetail-err', err);
                    });
                this.$emit('clickVideo');
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .video-title {
        ellipsis();
        height: 14px;
        font-size: 14px;
        color: gray6;
        line-height: 14px;
        margin-top: 10px;
    }

    .single-video-container {
        height: 263px;
        width: 248px;
        background: white;
        border-radius: 8px;
        margin: 0 15px 16px 0;
        padding: 16px;
        flex-y(flex-start, space-between);

        img {
            width: 100%;
            height: 186px;
        }
    }

    .single-video:hover {
        cursor: pointer;
    }

    .video-title {
        width: 100%;
        ellipsis();
        margin-top: 16px;
    }

    .video-icon {
        margin-top: 14px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
        height: 17px;
        flex-x(flex-start);

        i {
            font-size: 14px;
            margin-right: 5px;
            color: #9DA4B3;
        }

        svg {
            icon-c(12px, #9DA4B3);
            fill: #9DA4B3;
            margin-right: 5px;
        }

        span {
            margin-right: 16px;
            flex-x();
        }
    }
</style>
